module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Gameboy-9f3a8a8098ad23f98a7001f977f98967.svg";